/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const o=(o,r)=>r&&"number"==typeof o?r.transform(o):o;export{o as getValueAsType};
//# sourceMappingURL=get-as-type.js.map
